module.exports = __webpack_public_path__ + "static/media/Edidiong.5f55ecdf.jpeg";